/**
 * Domain enum for extend direction (application layer)
 * Used when deleting changes to determine which adjacent change to extend/shift
 */
export enum ExtendDirection {
  Previous = 'previous',
  Next = 'next',
}
